export enum RouteType {
  Standalone,
  Regular,
}
